export default __webpack_public_path__ + "static/media/milky_way&tent.ac63445d.jpg";